import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { GenerationStage } from '../types/disclosures';
export function ProgressStages({
  stages
}: {
  stages: GenerationStage[];
}) {
  return <ul className="space-y-2.5" aria-live="polite" data-id="element-197" data-mp="1k44kx0y1w879">
      {stages.map(stage => <li key={stage.id} className="flex items-center gap-2.5 text-[13px]" data-id="element-198" data-mp="1f5baxihz2zbu">
          <span className="flex h-4 w-4 items-center justify-center" aria-hidden="true" data-id="element-199" data-mp="1f36ww7qd0jxu">
            {stage.state === 'done' ? <CheckIcon className="h-4 w-4 text-emerald-600" strokeWidth={3} data-id="element-200" data-mp="27u8h4n8wt5o8" /> : stage.state === 'active' ? <span className="relative flex h-2.5 w-2.5" data-id="element-201" data-mp="22tui1upad62c">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-400 opacity-70" data-id="element-202" data-mp="1xvsxt6g4j0pa" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-blue-600" data-id="element-203" data-mp="rg8j5htmjq3m" />
              </span> : <span className="h-2 w-2 rounded-full bg-slate-200" data-id="element-204" data-mp="mf2mxa0r9kpc" />}
          </span>
          <span className={stage.state === 'pending' ? 'text-slate-400' : stage.state === 'active' ? 'font-medium text-slate-900' : 'text-slate-600'} data-id="element-205" data-mp="p8kwgbqda9lr">
            {stage.label}
          </span>
        </li>)}
    </ul>;
}